exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acd_wrap1UBDC {\n  overflow-y: scroll;\n  height: calc(100vh - 95px); }\n\n.acd_wrap1UBDC::-webkit-scrollbar-track {\n  background-color: #F5F5F5; }\n\n.acd_wrap1UBDC::-webkit-scrollbar {\n  width: 3px;\n  background-color: #F5F5F5; }\n\n.acd_wrap1UBDC::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 6px;\n  cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"wrap": "acd_wrap1UBDC"
};